import React, { createContext, useContext, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import { useAuth0 } from '@auth0/auth0-react';
import { statusCheck } from 'utils/statusCheck';
import { Loader } from 'components/Loader';
import { useConfig } from 'components/providers/Config';

const StoresContext = createContext([]);

export const useStores = () => useContext(StoresContext);

export const StoresProvider = ({ children }) => {
    const Router = useRouter();
    const config = useConfig();
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(true);
    const { getAccessTokenSilently, loginWithRedirect } = useAuth0();

    const fetchData = async () => {
        try {
            const accessToken = await getAccessTokenSilently();

            const res = await fetch(`${config.api.API_HOST}/stores`, {
                headers: {
                    Authorization: 'Bearer ' + accessToken
                }
            });

            if (statusCheck(res, Router, loginWithRedirect)) {
                return setStores(await res.json());
            }

            throw new Error('Failed to load jobs');
        } catch (error) {
            Router.push('/err');
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        fetchData();
    }, [children])

    if (loading) {
        return <Loader fullheight={"true"} />
    }

    return (
        <StoresContext.Provider value={stores}>
            {children}
        </StoresContext.Provider>
    )
};
